module.exports = __webpack_public_path__ + "static/media/ravi.c9509ee7.JPG";